/* eslint-disable max-len */
import React, { PureComponent } from 'react';
import { getFaqAccordionContent, getFaqAccordionSectionInfo } from 'lib/apps/catalogue/utils/cardContentGenerators';
import Accordion from 'widgets/Accordion/Accordion';
import AccordionElement from 'widgets/Accordion/AccordionElement';
import Button from 'lib/widgets/Button/Button';

class FaqAccordionSection extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAdditionalFaqs: false,
      ...getFaqAccordionContent(),
      ...getFaqAccordionSectionInfo(),
    };
  }

  handleShowMoreFaqs = () => {
    this.setState(prevState => ({ showAdditionalFaqs: !prevState.showAdditionalFaqs }));
  };

  render() {
    const { showAdditionalFaqs, faqs, additionalFaqs, sectionTitle, footerMoreQuestions, footerButtonTextMoreFaqs, footerHelpCentreLink, footerHelpCentreLinkText } = this.state;

    return (
      <section className="faq-accordion-section">
        <h2 className="faq-accordion__title">{sectionTitle}</h2>
        <div className="faq-accordion__initial">
          <Accordion>
            {faqs.map(faq => (
              <AccordionElement key={faq.id} title={faq.title}>
                {typeof faq.content === 'string' ? (
                  <p>{faq.content}</p>
                ) : (
                  faq.content
                )}
              </AccordionElement>
            ))}
          </Accordion>
        </div>

        {showAdditionalFaqs && (
          <div className={`faq-accordion__additional ${showAdditionalFaqs ? 'faq-accordion__additional--show' : ''}`}>
            <Accordion>
              {additionalFaqs.map(faq => (
                <AccordionElement key={faq.id} title={faq.title}>
                  {typeof faq.content === 'string' ? (
                    <p>{faq.content}</p>
                  ) : (
                    faq.content
                  )}
                </AccordionElement>
              ))}
            </Accordion>
          </div>
        )}

        <div className="faq-accordion__footer">
          <p className="faq-accordion__footer-title">{footerMoreQuestions}</p>
          <Button
            secondary
            className="faq-accordion__footer-btn"
            onClick={this.handleShowMoreFaqs}
            style={{ display: showAdditionalFaqs ? 'none' : 'block' }}
          >
            {footerButtonTextMoreFaqs}
          </Button>
          {showAdditionalFaqs && (
            <a
              className={`faq-accordion__footer-link ${showAdditionalFaqs ? 'faq-accordion__footer-link--show' : ''}`}
              href={footerHelpCentreLink}
            >
              {footerHelpCentreLinkText}
            </a>
          )}
        </div>
      </section>
    );
  }
}

export default FaqAccordionSection;
